import { createAsyncThunk } from '@reduxjs/toolkit'
// import axios from 'axios'
// import i18next from 'i18next'
import { APIError, authenticatedRequest, getExceptionPayload } from '../axiosConfiguration'
import {
  FinancialExposureRequest,
  FinancialExposureData,
} from '../type/financialExposures'
import * as layoutActions from './layout'

export const getFinancialExposures = createAsyncThunk<FinancialExposureData, FinancialExposureRequest, { rejectValue: APIError }>(
  'financialExposure/getFinancialExposures',
  async (requestPayload, { dispatch, rejectWithValue }) => {
    dispatch(layoutActions.startLoading())

    try {
      const instance = await authenticatedRequest()
      const res = await instance.get<FinancialExposureData>('/financialexposure')

      dispatch(layoutActions.endLoading())

      return res.data
    } catch (error) {
      const err = getExceptionPayload(error, 'financialExposure:error.getFinancialExposures')

      dispatch(layoutActions.endLoading())
      dispatch(layoutActions.showToast({ summary: err.message, severity: 'error' }))

      return rejectWithValue(err)
    }
  },
)
